const initialState = {
    showTemplateBtn: false,
    broadcast: {
        moduleIndex: 1,
        csvFile: "",
        uploadFile: "",
        selectedTemp: "",
        headerArray: "",
        csvData: "",
        csvHeaders: "",
        uploadFileName: ""
    }
}

const whatsAppModuleReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'HANDLE_SHOW_TEMPLATE_BTN':
            return { ...state, showTemplateBtn: action.value }
            break
        case 'HANDLE_BROADCAST':
            const { value, type } = action.value
            switch (type) {
                case "moduleIndex":
                    return { ...state, broadcast: { ...state.broadcast, moduleIndex: value } }
                    break
                case "csvFile":
                    return { ...state, broadcast: { ...state.broadcast, csvFile: value } }
                    break
                case "uploadFile":
                    return { ...state, broadcast: { ...state.broadcast, uploadFile: value } }
                    break
                case "temp":
                    return { ...state, broadcast: { ...state.broadcast, selectedTemp: value } }
                    break
                case "headerArray":
                    return { ...state, broadcast: { ...state.broadcast, headerArray: value } }
                    break
                case "csvData":
                    return { ...state, broadcast: { ...state.broadcast, csvData: value } }
                    break
                case "csvHeaders":
                    return { ...state, broadcast: { ...state.broadcast, csvHeaders: value } }
                    break
                case "uploadFileName":
                    return { ...state, broadcast: { ...state.broadcast, uploadFileName: value } }
                case "reset":
                    return { ...state, broadcast: { moduleIndex: 1, csvFile: "", uploadFile: "", selectedTemp: "", headerArray: "", csvData: "", csvHeaders: "", uploadFileName: "" } }
                    break
                default:
                    break
            }
            break
        default:
            return state
    }
}

export default whatsAppModuleReducer